'use client';

import Image from '@/components/Image';
import Link from 'next/link';
import { useStore } from '@/providers/app-store-provider';
import { formatPriceNumberWithSymbol, priceInfo } from '@/utils/price';

interface CandyProductsProps {
  pageData: any;
  productList: any[];
}

export default function CandyProducts({ pageData, productList = [] }: CandyProductsProps) {
  const title = pageData?.product?.title || '';
  const currency = useStore((state) => state.currency);
  const userInfo = useStore((state) => state.userInfo);

  // 获取会员背景色
  const getMemberBackgroundColor = (level: number) => {
    const colors = {
      0: '#CAD8FC',
      1: '#B2CEF0',
      2: '#F7BD9E',
      3: 'linear-gradient(90deg, #C693FF 0%, #CBEAFF 100%)',
    };
    return colors[level as keyof typeof colors] || '#CAD8FC';
  };

  // 安全检查
  if (!Array.isArray(productList) || productList.length === 0) {
    return null;
  }

  return (
    <div className="product-list dmp-product bg-[#0f0f0f] py-[40.5px] border-b border-white">
      <h1 className="title font-bb text-[40px] text-center text-white w-[290px] mx-auto leading-[35px]">
        {title}
      </h1>
      <div className="ul mt-[33.5px]">
        {productList.map((item: any, index: number) => {
          // 安全检查每个商品项
          if (!item || !item.shop_sku) {
            return null;
          }

          const productPrice = priceInfo(userInfo, item, currency) || { price: 0, sell_price: 0 };

          return (
            <Link
              key={item.id || item.shop_sku || index}
              href={`/goods-detail/${item.shop_sku}`}
              className="li-box flex items-center justify-center cursor-pointer"
            >
              <div className="li-left w-[191.7px] h-auto relative mb-[10px]">
                {/* 会员标签 */}
                {userInfo?.is_member === 1 &&
                  item[`discount_percent_v${userInfo.member_level}`] > 0 && (
                    <div
                      className="member absolute top-[4px] right-[5px] rounded-[4px] px-[6px] text-[#282828]"
                      style={{
                        height: '16px',
                        lineHeight: '16px',
                        fontSize: '11px',
                        backgroundColor: getMemberBackgroundColor(userInfo.member_level),
                      }}
                    >
                      V{userInfo.member_level}
                    </div>
                  )}

                <Image
                  src={item.product_image || '/placeholder.jpg'}
                  alt={item.name || item.short_name || 'Product'}
                  width={192}
                  height={200}
                  className="w-[191.7px] h-auto"
                />
                <span className="short_name absolute bottom-[30px] left-[45px] w-[70px] h-[36px] leading-[36px] text-center text-primary-black text-[12px] box-border font-bb">
                  {item.short_name || ''}
                </span>
                <div className="price absolute bottom-[2px] left-0 w-full box-border text-center">
                  <div className="notranslate">
                    <span className="now-price text-primary-black text-[12px]">
                      {formatPriceNumberWithSymbol(productPrice.sell_price, currency)}
                    </span>
                    {productPrice.sell_price !== productPrice.price && (
                      <span className="old-price text-secondary-black text-[12px] ml-[5px] line-through text-[#A9A9A9]">
                        {formatPriceNumberWithSymbol(productPrice.price, currency)}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="li-right">
                <Image
                  src={item.nav_image || '/placeholder.jpg'}
                  alt={`${item.short_name || 'Product'} glasses ${index + 1}`}
                  width={124}
                  height={100}
                  className="w-[124px] ml-[10px]"
                />
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
